import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
interface TeamMemberProps {
  name: string;
  title: string;
  bio: string;
  imageUrl: string;
  index: number;
}
const TeamMember = ({
  name,
  title,
  bio,
  imageUrl,
  index
}: TeamMemberProps) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 50
  }} animate={inView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.7,
    delay: index * 0.2
  }} className="w-full md:w-[calc(33.333%-1rem)]" data-id="element-187">
      <div className="h-full bg-gradient-to-b from-[#111111] to-[#0a0a0a] border border-gray-800 rounded-lg overflow-hidden shadow-xl flex flex-col p-6" data-id="element-188">
        <div className="flex items-center mb-4" data-id="element-189">
          <div className="w-16 h-16 mr-4 rounded-full overflow-hidden border-2 border-[#ffdf07]" data-id="element-190">
            <img src={imageUrl} alt={name} className="w-full h-full object-cover object-center" data-id="element-191" />
          </div>
          <div data-id="element-192">
            <h3 className="text-xl text-white mb-1 typekit-heading" data-id="element-193">{name}</h3>
            <p className="text-[#ffdf07] text-xs" data-id="element-194">{title}</p>
          </div>
        </div>
        <p className="text-gray-300 libre-caslon-text-regular leading-relaxed text-xs mb-3" data-id="element-195">
          {bio}
        </p>
      </div>
    </motion.div>;
};
const TeamSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const team = [{
    name: 'Ivan Acuna',
    title: 'Content Strategy & Brand Building',
    bio: "Ivan Acuna is the host of The Deal Flow Show and the Founder of The Cognitive Leverage Group, a firm dedicated to building brands for investment firms, family offices, and leaders in private equity. His experience in content strategy has helped generate billions of monthly organic impressions, and his firm is now helping the world's most elite dealmakers.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mRAuUG8YWv2RMwmk41SxrT/pasted-image.jpg'
  }, {
    name: 'Elena Ivanov',
    title: 'Transaction & M&A Specialist',
    bio: "Forged in the high-stakes world of transaction diligence at EY-Parthenon, Elena brings the analytical firepower of a Big Four accounting firm to your business. Having spent her career on the buyer's side of the table, she has an insider's understanding of how private equity firms evaluate, value, and acquire companies. Her expertise allows her to dissect a business through the critical eye of an investor, turning potential liabilities into defensible strengths.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3k5yM8Z1hHgh5YjPipTp5m/pasted-image.jpg'
  }, {
    name: 'Andra Grija, MBA',
    title: 'Corporate & Healthcare Finance Expert',
    bio: "Andra's expertise was forged in the healthcare sector, where she drove financial strategy for clinic expansions at Esperanza Health Centers. She then brought that frontline experience to the corporate world, leading complex budgeting and forecasting initiatives at the multi-billion dollar firm JLL. Holding an MBA in Finance, Andra is the bridge between the operational realities of a Main Street clinic and the rigorous standards of Wall Street, ensuring your business is positioned for maximum value.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyVG1jyaW9YHXNQHLxmwxz/pasted-image.jpg'
  }];
  return <section className="w-full bg-black py-20 px-4" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-198">
          <h2 className="text-white text-3xl md:text-4xl mb-6 typekit-heading" data-id="element-199">
            Meet the Team
          </h2>
          <p className="text-gray-300 libre-caslon-text-regular leading-relaxed max-w-3xl mx-auto" data-id="element-200">
            Our team brings together expertise from Wall Street, Big Four
            consulting, and healthcare operations to provide you with unmatched
            guidance for your exit.
          </p>
        </motion.div>
        <div className="flex flex-col md:flex-row justify-between gap-4" data-id="element-201">
          {team.map((member, index) => <TeamMember key={index} name={member.name} title={member.title} bio={member.bio} imageUrl={member.imageUrl} index={index} data-id="element-202" />)}
        </div>
      </div>
    </section>;
};
export default TeamSection;